import React, { memo, useState } from 'react'
import { withTranslation, useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import useStyles from './noteComponentStyle'
import Typography from '../../atoms/display/typography'
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'
import { isArray } from '../../../utils/customMethods'
import {
  AccessTimeRounded as ClockIcon,
  DoneRounded as CheckIcon,
  DoneAllRounded as CheckAllIcon,
  ErrorRounded as ErrorIcon,
} from '@material-ui/icons'

const NoteComponent = ({
  element = null,
  privateText = false,
  userList = [],
}) => {
  const { t } = useTranslation()
  const size = useSelector((state) => state.preferences)
  let useStylesParams = {
    size: size,
  }

  const theme = useTheme()
  const classes = useStyles(useStylesParams)
  const [isOpen, setIsOpen] = useState(true)

  function toggle() {
    setIsOpen((prev) => !prev)
  }

  const activeConversation = useSelector((state) => state.activeConversation)
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const user = useSelector((state) => state.user)

  const renderHeader = () => {
    return (
      <>
        <div className={classes.headerMaster} onClick={toggle}>
          <Typography
            variant="body1"
            component="h4"
            style={{ color: '#009EE2' }}
          >
            {`${
              privateText === false
                ? t('fields.publicNote.label')
                : t('fields.privateNote.label')
            }`}
          </Typography>
          <span
            style={{
              marginRight: 6,
              color:
                theme.palette.type === 'dark'
                  ? '#fff'
                  : theme.palette.primary.secondary,
            }}
          >
            {t(isOpen ? 'commons.ViewLess' : 'commons.ViewMore')}
            {isOpen ? <ArrowDropUp /> : <ArrowDropDown />}
          </span>
        </div>
      </>
    )
  }

  const renderIcon = () => {
    const status = element?.data?.status
    return (
      <>
        {status?.sending ? (
          <ClockIcon
            style={{
              fontSize: 14,
              marginRight: 5,
              marginBottom: -2,
            }}
          />
        ) : status?.sent ? (
          <CheckIcon
            style={{
              fontSize: 14,
              marginRight: 5,
              marginBottom: -2,
              color: theme.palette.primary.main,
            }}
          />
        ) : status?.read ? (
          <CheckAllIcon
            style={{
              fontSize: 14,
              marginRight: 5,
              marginBottom: -2,
              color: theme.palette.primary.main,
            }}
          />
        ) : status?.error ? (
          <ErrorIcon
            style={{
              fontSize: 14,
              marginRight: 5,
              marginBottom: -2,
              color: theme.palette.error.main,
            }}
          />
        ) : (
          <CheckAllIcon
            style={{
              fontSize: 14,
              marginRight: 5,
              marginBottom: -2,
              color: theme.palette.primary.main,
            }}
          />
        )}
      </>
    )
  }

  const renderNote = () => {
    if (isOpen) {
      if (
        (privateText === false && element?.text) ||
        (privateText === false && element?.filesOperator?.length > 0)
      ) {
        return (
          <div className={classes.masterContainer}>
            <div className={classes.noteContainer}>
              <>
                {renderHeader()}
                <p className={classes.noteContent}>
                  {element.text ||
                    (element?.filesOperator?.length &&
                      t('fields.attachFiles.files'))}
                </p>
                {element?.filesOperator?.length > 0 && (
                  <>
                    <p style={{ textAlign: 'right', margin: '1em' }}>
                      {t('commons.attachedDocuments')}
                    </p>
                    {isArray(element?.filesOperator) &&
                      element?.filesOperator?.map((file, idx) => {
                        let fileSize = file?.file_size / 1000000
                        fileSize = fileSize?.toFixed(3)
                        return (
                          <div
                            key={idx}
                            className={classes.fileList}
                            style={{
                              textAlign: 'right',
                              fontSize: '10px',
                              display: 'flex',
                              justifyContent: 'flex-end',
                              margin: '1em 1em 1em 0',
                            }}
                          >
                            <div style={{ maxWidth: '75%' }}>
                              <a href={file?.file_url} target="_blank">
                                <i>
                                  <span
                                    style={{
                                      marginRight: '1em',
                                      color: '#009EE2',
                                    }}
                                  >
                                    {file?.file_name}
                                  </span>
                                </i>
                              </a>
                            </div>
                            <div style={{ marginLeft: '1em' }}>
                              <span>{`(${fileSize} mb)`}</span>
                            </div>
                          </div>
                        )
                      })}
                  </>
                )}
              </>
            </div>
          </div>
        )
      } else if (privateText === true && element?.private_note_operator) {
        return (
          <div className={classes.masterContainer}>
            <div className={classes.noteContainer}>
              <>
                {renderHeader()}
                <p className={classes.noteContent}>
                  {element.private_note_operator}
                </p>
              </>
            </div>
          </div>
        )
      }
    } else {
      return (
        <div className={classes.masterContainer}>
          <div className={classes.noteContainer}>{renderHeader()}</div>
        </div>
      )
    }
  }

  return (
    <>
      {(element?.text ||
        element?.private_note_operator ||
        element?.filesOperator?.length > 0) && <>{renderNote()}</>}
    </>
  )
}

export default withTranslation()(memo(NoteComponent))
